import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import config from '../../config';

export default function Loader({ message = '', hideSpinner = false }) {
    return (
        <div className="loader-wrapper w-100" style={{ minHeight: '300px', textAlign: 'center', padding: '50px' }}>
            <img src={`${config.staticUrl}images/app/logo-alt.png`} alt={config.application.name} /><br />
            {message && (
                <div className="my-2">
                    {message}
                </div>
            )}
            {!hideSpinner && <FontAwesomeIcon icon="spinner" spin size="lg" className="text-primary" />}
        </div>
    );
}

Loader.propTypes = {
    message: PropTypes.string,
    hideSpinner: PropTypes.bool,
};
